import "./App.css";
import Navbar from "./components/Navbar";
import { Routes, Route } from "react-router-dom";
import { useState } from "react";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import News from "./pages/News";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import Phones from "./pages/Phones";
import Laptop from "./pages/Laptop";
import Accessories from "./pages/Accessories";
import Appliances from "./pages/Appliances";
import Games from "./pages/Games";
import SingleProduct from "./components/Shop/SingleProduct";
import CartPage from "./pages/CartPage";
// import { useEffect } from "react";
import { CartProvider } from "./CartContext";

function App() {
  const [menuToggler, setMenuToggler] = useState(false);
  // const [carts, setCarts] = useState([]);

  // useEffect(() => {
  //   fetch("/products.json")
  //     .then((res) => res.json())
  //     .then((data) => setCarts(data));
  // }, []);

  // console.log(carts);

  // console.log(a);
  return (
    <div
      className={`${
        menuToggler ? "h-[100vh] overflow-hidden" : ""
      } overflow-x-hidden`}
    >
      <CartProvider>
        <Navbar menuToggler={menuToggler} setMenuToggler={setMenuToggler} />
        <Routes>
          <Route
            path="/"
            element={
              <Home menuToggler={menuToggler} setMenuToggler={setMenuToggler} />
            }
          />
          <Route
            path="/shop"
            element={
              <Shop
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
              />
            }
          />
          <Route
            path="/news"
            element={
              <News
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
              />
            }
          />
          {/* <Route
            path="/about"
            element={
              <About
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
              />
            }
          /> */}
          <Route
            path="/contact"
            element={
              <Contact
                onClick={() => {
                  window.scrollTo({ top: 0 });
                }}
              />
            }
          />
          <Route path="/phones" element={<Phones />} />
          <Route path="/laptop" element={<Laptop />} />
          <Route path="/accessories" element={<Accessories />} />
          <Route path="/appliances" element={<Appliances />} />
          <Route path="/games" element={<Games />} />
          <Route path="shop/:id" element={<SingleProduct />} />
          <Route path="/cart-page" element={<CartPage />} />
        </Routes>
      </CartProvider>
      {/* <Outlet /> */}
      <Footer />
    </div>
  );
}

export default App;
